import React from 'react';
import TableTop from 'cccisd-tabletop';
import messageLogByMessage from './messageLogByMessage.graphql';
import messageLogByRecipient from './messageLogByRecipient.graphql';
import Tooltip from 'cccisd-tooltip';
import IconWarning from 'cccisd-icons/warning2';

const Fortress = window.cccisd.fortress.user;

const byMessage = {
    query: messageLogByMessage,
    graphqlVariables: { groupId: Fortress.acting.group_id },
    rowKey: 'messageId',
    isAscentOrder: false,
    handle: 'messageLogByMessage',
    columns: [
        {
            name: 'attemptedAt',
            label: 'Date',
            sort: true,
            filter: true,
            filterSettings: { type: 'date' },
            width: '170px',
        },
        {
            name: 'messageType',
            label: 'Type',
            sort: true,
            filter: true,
        },
        {
            name: 'status',
            label: 'Status',
            sort: true,
            filter: true,
            render: ({ row }) => {
                if (
                    row.statusMessage != null &&
                    (row.status.toLowerCase() === 'failed' || row.status.toLowerCase() === 'failure')
                ) {
                    return (
                        <>
                            {row.status}
                            &nbsp;
                            <Tooltip title={row.statusMessage}>
                                <IconWarning />
                            </Tooltip>
                        </>
                    );
                }

                return row.status;
            },
        },
        {
            name: 'action',
            label: 'Action',
            sort: true,
            filter: true,
        },
        {
            name: 'pawn.user.username',
            label: 'Username',
            sort: true,
            filter: true,
            tooltip: (
                <div>
                    If the recipient is a user in the system, the username is shown.
                    <div>
                        If not, we are rendering <i>Sent To:</i> and the email address of the recipient.
                    </div>
                    <div>Sorting and filtering on this column is not exact.</div>
                </div>
            ),
            render: ({ row }) => {
                const messageSentTo = () => {
                    const header = row['messageInfo.headers'];
                    if (header && header.includes('To:') && header.includes('MIME-Version:')) {
                        return header.substring(header.indexOf('To:') + 3, header.lastIndexOf('MIME-Version:'));
                    }

                    const to = row['messageInfo.to'];
                    if (to) {
                        return to;
                    }

                    return 'Missing ' + (row.messageType === 'email' ? 'Email Address' : 'Phone Number');
                };

                return row['pawn.user.username'] ? row['pawn.user.username'] : `Sent To: ${messageSentTo()}`;
            },
            filterSettings: {
                type: 'regex',
                field: 'messageInfo.headers',
                preparePattern: value => `"[^"]*${value}`,
            },
        },
        {
            name: 'pawn.pawn.pawnId',
            label: 'System ID',
            sort: true,
            filter: true,
        },
        {
            name: 'pawn.pawn.roleName',
            label: 'Role',
            tooltip: (
                <div>
                    The role is Youth if it is an message for an evaluation cycle and sent to a recipient associated
                    with the youth.
                </div>
            ),
            sort: true,
            filter: true,
        },
        {
            name: 'pawn.parentGroup.anyGroup.group.label',
            label: 'Group',
            sort: true,
            filter: true,
        },
        {
            name: 'messageInfo.subject',
            label: 'Message Subject',
            sort: true,
            filter: true,
        },
    ],
};

const byRecipient = {
    query: messageLogByRecipient,
    graphqlVariables: { groupId: Fortress.acting.group_id },
    rowKey: 'pawn.pawnId',
    handle: 'messageLogByRecipient',
    columns: [
        {
            name: 'user.username',
            label: 'Username',
            sort: true,
            filter: true,
        },
        {
            name: 'pawn.pawnId',
            label: 'System ID',
            sort: true,
            filter: true,
        },
        {
            name: 'pawn.roleName',
            label: 'Role',
            sort: true,
            filter: true,
        },
        {
            name: 'parentGroup.anyGroup.group.label',
            label: 'Group',
            sort: true,
            filter: true,
        },
        {
            name: 'messageCount',
            label: '# Messages',
            sort: true,
            filter: true,
        },
        {
            name: 'messageSummary.minDate',
            label: 'First message',
            width: '170px',
            sort: true,
            filter: true,
            filterSettings: { type: 'date' },
        },
        {
            name: 'messageSummary.maxDate',
            label: 'Latest message',
            width: '170px',
            sort: true,
            filter: true,
            filterSettings: { type: 'date' },
        },
    ],
};
export default class MessageLogs extends React.Component {
    render() {
        return (
            <div>
                <TableTop
                    handle="messageLog"
                    saveState
                    selectedProductId={null}
                    views={[
                        {
                            handle: 'messageLogByMessage',
                            title: 'Message Log - by Message',
                            table: byMessage,
                        },
                        {
                            handle: 'messageLogByRecipient',
                            title: 'Message Log - by Recipient',
                            table: byRecipient,
                        },
                    ]}
                />
            </div>
        );
    }
}
